import script from "./ComingSoonView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComingSoonView.vue?vue&type=script&setup=true&lang=ts"

import "./ComingSoonView.vue?vue&type=style&index=0&id=235842ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-235842ea"]])

export default __exports__